import React, { Fragment } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Fade from 'react-reveal/Fade';
import Text from 'common/src/components/Text';
import Heading from 'common/src/components/Heading';
import Button from 'common/src/components/Button';
import Box from 'common/src/components/Box';
import Image from 'common/src/components/Image';
import Container from 'common/src/components/UI/Container';
import Rating from 'common/src/components/Rating';
import GlideCarousel from 'common/src/components/GlideCarousel';
import GlideSlide from 'common/src/components/GlideCarousel/glideSlide';
import { SectionHeader } from '../appClassic.style';
import PropTypes from 'prop-types';
import SectionWrapper, { BoxWrapper } from './company.style';
import team from 'common/src/assets/image/appClassic/team.png';
import pmLogo from 'common/src/assets/image/appClassic/pm.png';
import reactLogo from 'common/src/assets/image/appClassic/react.png';

const WhyCard = ({ imageSrc, title, bullets, delay }) => {
  return (
    <Fade up delay={delay}>
      <div style={{ display: "flex", flexDirection: "column", marginRight: "25px", flex: "0 0 320px", marginBottom: "25px" }}>
        <div style={{ width: "100px", height: "110px", marginBottom: "15px" }}>
          <Image src={imageSrc} />
        </div>
        <div style={{ marginBottom: "25px", fontWeight: 600 }}>
          {title}
        </div>
        <div>
          <ul>
            {bullets.length > 0 && bullets.map((bullet, index) =>
              <li key={index} style={{ display: "flex", alignItems: "flex-start" }}>
                <span style={{ fontSize: "30px", marginRight: "20px" }}>{"\u2022"}</span>{bullet}
              </li>
            )}
          </ul>
        </div>
      </div>
    </Fade>
  )
}

const Company = ({ sectionTitle, sectionSubTitle }) => {

  return (
    <SectionWrapper id="company">
      <Container>
        <SectionHeader>
          <Fade up>
            <Text content={"COMPANY"} {...sectionSubTitle} />
            <Heading content={"Transparency is the currency of trust"} {...sectionTitle} />
            <Text className="subtitle" content={`Technology entrepreneurs, specialized in React.js applications, we are praised for our efficiency and quality of work.
Having worked with European institutions to startups in their infancy, we are experienced in agile methodology and delivering high quality software.`} />
          </Fade>
        </SectionHeader>
        <BoxWrapper>
          <div style={{ marginBottom: "60px" }}>
            <Heading content={"Why us?"} />
          </div>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <WhyCard imageSrc={reactLogo} delay={100} title="React Specialisation"
              bullets={["we organize training courses and workshops", "we take part in meetings of the frontend community as participants and speakers",
                "we build and share reusable frontend components, libraries, rules and style guides"]} />
            <WhyCard imageSrc={team} delay={200} title="Experienced Team"
              bullets={["we are experienced in building advanced corporate systems and challenging, innovative products",
                "we are well-versed in various project management and collaboration tools",
                "the average experience of our developers is 5 years"]} />
            <WhyCard imageSrc={pmLogo} delay={300} title="Complex Projects"
              bullets={["we organize training courses and workshops", "we take part in meetings of the frontend community as participants and speakers",
                "we build and share reusable frontend components, libraries, rules and style guides"]} />
          </div>
        </BoxWrapper>
      </Container>
    </SectionWrapper >
  );
};

Company.propTypes = {
  sectionTitle: PropTypes.object,
  sectionSubTitle: PropTypes.object,
};

Company.defaultProps = {
  sectionSubTitle: {
    as: 'span',
    display: 'block',
    textAlign: 'center',
    fontSize: '14px',
    letterSpacing: '0.15em',
    fontWeight: '700',
    color: '#0D5EAF',
    mb: '10px',
  },
  sectionTitle: {
    textAlign: 'center',
    fontSize: "24px!important",
    fontWeight: '400!important',
    color: '#0f2137!important',
    letterSpacing: '-0.025em!important',
    mb: '0',
  }
};

export default Company;
